<template>
  <!--<div class="card">-->
    <!--<slot></slot>-->
    <!--<div class="price">-->
      <!--<div class="center" v-if="data.type === 1">-->
        <!--<span :class="{big:big,mid:mid,small:small}">{{Number(data.amount)}}</span>元-->
      <!--</div>-->
      <!--<div class="center" v-else-if="data.type === 2">-->
        <!--<span class="quanmian">全免</span>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="info">-->
      <!--<div class="name" :class="{white:nouse}">{{data.name}}</div>-->
      <!--<p class="out-title" :class="{white:nouse}">有效期：<router-link tag="a" href="javascript:;" class="use" v-if="!nouse" :to="buildurl(data)">立即使用</router-link></p>-->
      <!--<p class="out-date" :class="{white:nouse}">{{data.start_date}} - {{data.end_date}}</p>-->
    <!--</div>-->
  <!--</div>-->
  <div class="card">
    <div class="col-1">
      <div class="f">
        <template v-if="data.type === 1">
          <span class="i">¥</span><span class="n">{{Number(data.amount)}}</span>元优惠券
        </template>
        <template v-else-if="data.type === 2">
          <span class="n">全免</span>
        </template>
      </div>
      <div class="s">{{data.name}}</div>
      <div class="t">{{data.start_date}} - {{data.end_date}}</div>
    </div>
    <div class="col-2">
      <!--<div>已使用</div>-->
      <router-link tag="a" :to="buildurl(data)" v-if="type === '1'" class="b">使用</router-link>
      <div v-if="type === '2'" class="t">已使用</div>
      <div v-if="type === '3'" class="t">已过期</div>
      <slot></slot>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: ['nouse', 'data', 'type'],
  data() {
    return {
      amount: 0
    }
  },
  created() {
    // console.log(String(Number(this.data.amount)))
    this.amount = String(Number(this.data.amount)).length
  },
  computed: {
    big() {
      return this.amount >= 3
    },
    mid() {
      return this.amount >= 4
    },
    small() {
      return this.amount >= 5
    }
  },
  methods: {
    buildurl(item) {
      let url = '/'
      // debugger
      // if (item.course_info && item.course_info.type === 1) {
      //   // 微课
      //   url = '/play/' + item.course_info.id + '/' + item.course_info.video_ids.split(',')[0]
      // } else if (item.course_info && item.course_info.type === 2) {
      //   // 体系课
      //   url = '/systematic/' + item.course_info.id
      // }
      return item.jump_url ? item.jump_url : url
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .card{
    width: 100%;
    min-height: size(176)
    display flex
    flex-wrap nowrap
    flex-direction row
    justify-content space-between
    align-items center
    background-image: url('~common/image/coupon-bg.png')
    -webkit-background-size: 100% 100%
    background-size: 100% 100%
    .col-1{
      width: 77%;
      padding-left: size(24)
      .f{
        color: #ff5500
        font-size size(26)
        font-weight 800
        .i{
          font-size size(22)
        }
        .n{
          font-size size(50)
        }
      }
      .s{
        color: #686868
        font-size size(24)
        margin-top: size(8)
        line-height 1.1
      }
      .t{
        line-height 1.1
        color: #686868
        font-size size(20)
        margin-top: size(8)
      }
    }
    .col-2{
      width: 23%;
      text-align center
      color rgba(239, 114, 81, 0.46);
      font-size size(34)
      .b{
        font-size: size(26)
        color: #fff
        display inline-block;
        background-image: linear-gradient(90deg, #ffa51d 0%, #ff5700 100%);
        border-radius: size(24)
        padding: size(10) size(20)
      }
    }
  }
  /**
  .card
    position relative
    >img
      display block
      width 100%
  .v-mid
    position absolute
    top 50%
    transform translateY(-50%)
  .h-mid
    position absolute
    left 50%
    transform translateX(-50%)
  .center
    position absolute
    left 50%
    top 50%
    transform translate(-50%,-50%)
  .price
    color #fff
    width percentage(180 /690)
    height 100%
    position absolute
    left size(10)
    top 0
    span
      font-size size(90)
      font-weight 700
    .big
      font-size size(68)
    .mid
      font-size size(56)
    .small
      font-size size(44)
  .info
    position absolute
    width percentage(450/690)
    top percentage(24/180)
    right percentage(20/690)
  .name
    color #666
    font-size size(32)
    line-height size(45)
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
  .use
    // float right
    font-size size(26)
    color #ffffff
    background #ff8125
    line-height 1
    border-radius size(45/2)
    padding size(19/2) size(22)
    position absolute
    right 0
    top size(-16)
  .out-title,.out-date
    font-size size(26)
    color #999
  .out-title
    margin size(12) 0
    position relative
  .white
    color #fff!important
  .quanmian
    font-size size(70)!important
    white-space nowrap
    **/
</style>



// WEBPACK FOOTER //
// src/components/personal/coupon/coupon-card.vue